var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mt-10" },
        [
          _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "pro-section-lbl" }, [
              _vm._v("Postal Code(s)"),
            ]),
          ]),
          _c("v-col", { staticClass: "pl-0 mt-n2", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "pro-section-explainer" }, [
              _vm._v("Enter one postal code per line:"),
            ]),
          ]),
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c("v-textarea", {
                staticClass: "zip-codes-textarea",
                attrs: {
                  placeholder: "No postal code entered",
                  outlined: "",
                  rows: "8",
                  "background-color": "white",
                  error: _vm.hasValidationErrors,
                  "error-messages": _vm.validationErrors,
                },
                model: {
                  value: _vm.zipCodesText,
                  callback: function ($$v) {
                    _vm.zipCodesText = $$v
                  },
                  expression: "zipCodesText",
                },
              }),
              _vm.zipCodesText &&
              (_vm.validCodes.length > 0 || _vm.invalidCodes.length > 0)
                ? _c("div", { staticClass: "validation-summary mt-2" }, [
                    _vm.validCodes.length > 0
                      ? _c(
                          "div",
                          { staticClass: "valid-codes-summary" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { color: "success", small: "" },
                              },
                              [_vm._v("mdi-check-circle")]
                            ),
                            _c("span", { staticClass: "success-text" }, [
                              _vm._v(
                                _vm._s(_vm.validCodes.length) +
                                  " valid postal code" +
                                  _vm._s(_vm.validCodes.length !== 1 ? "s" : "")
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.invalidCodes.length > 0
                      ? _c(
                          "div",
                          { staticClass: "invalid-codes-summary mt-1" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { color: "error", small: "" },
                              },
                              [_vm._v("mdi-alert-circle")]
                            ),
                            _c("span", { staticClass: "error-text" }, [
                              _vm._v(
                                _vm._s(_vm.invalidCodes.length) +
                                  " invalid postal code" +
                                  _vm._s(
                                    _vm.invalidCodes.length !== 1 ? "s" : ""
                                  )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }